/**
 * 找回密码相关API
 * */
import request from '@/utils/request'
import { request as http } from '@/utils/request'

const gateWay = '/permission'

/**
 * 找回密码-获取验证码图片---同注册
 * */

/**
 * 找回密码-验证邮箱
 * @params: [email]
 * */
export function apiValidateFPEmail(data) {
    return request({
        url: gateWay + '/register/validateFPEmail',
        method: 'post',
        data,
    })
}

/**
 * 找回密码-校验验证码图片
 * @params: []
 * */
// export function apiCaptchaValidate(data) {
//     return request({
//         url: gateWay + '/register/captcha',
//         method: 'post',
//         data,
//     })
// }

/**
 * 提交验证图形验证码，发送找回密码激活邮件
 * @params: {"email": "", "captcha": "", "language": "en"}language:中文不需要填写，英文状态下需要填写"en"
 * */
export function apiCaptchaEmailValidate(data) {
    return request({
        url: gateWay + '/register/findPassword/submit',
        method: 'post',
        data,
    })
}

/**
 * 提交验证手机短信验证码
 * @params: {"phone": "", "code": ""}
 * */
export function apiCaptchaPhoneValidate(data) {
    return http({
        url: gateWay + '/register/codeValidate',
        method: 'post',
        data,
    })
}

/**
 * 邮箱找回重置密码
 * @params: {"password": "", "key": ""}
 * */
export function apiEmailResetPassword(data) {
    return request({
        url: gateWay + '/register/find/password',
        method: 'post',
        data,
    })
}

/**
 * 手机验证码找回重置密码
 * @params: {"password": "", "key": ""}
 * */
export function apiPhoneResetPassword(data) {
    return http({
        url: gateWay + '/register/findPassword',
        method: 'post',
        data,
    })
}
